import { FC } from 'react';

import { AppModalProps } from '@/types/modal.type';
import { ModalView } from '@/Components/ModalView';
import { Button } from '@/Components/Button';
import { FlickAnimation } from '@/Components/FlickAnimation';
import { ExclamationSvg } from '@/Components/Icons/ExclamationSvg';

export type ResetPlayerDimensionsModalProps = AppModalProps<{
    onConfirm: () => void;
}>;

export const ResetPlayerDimensionsModal: FC<
    ResetPlayerDimensionsModalProps
> = ({ onClose, payload }) => {
    const onConfirm = () => {
        payload?.onConfirm();
        onClose();
    };

    return (
        <ModalView
            maxWidth="sm"
            onClose={onClose}
            onSubmit={onClose}
            contentContainerClassName="py-6 px-8 text-brand-ocean flex flex-col justify-center items-center">
            <div className="relative min-w-60 h-24 flex items-center justify-center">
                <FlickAnimation className="absolute z-10 bottom-5 left-11" />
                <div className="absolute bottom-5 right-20">
                    <ExclamationSvg className="[&_path]:fill-orange-500" />
                </div>
            </div>
            <div className="w-full !font-normal text-heading-five text-left text-gray-80 mb-2">
                When you turn on recommended dimensions, your custom dimensions
                will be reset.
            </div>
            <div className="mt-2 w-full flex items-center justify-center space-x-3">
                <Button
                    className="w-full h-9"
                    variant="danger"
                    onClick={onConfirm}>
                    Confirm & reset
                </Button>
                <Button
                    className="w-full h-9"
                    variant="default"
                    onClick={onClose}>
                    Cancel
                </Button>
            </div>
        </ModalView>
    );
};
